module.exports = __webpack_public_path__ + "img/undraw_Letter_re_8m03.43e1b411.svg";